var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-radius: 50%;\n  height: ', ';\n  width: ', ';\n  object-fit: cover;\n  box-shadow: s-depth(100);\n'], ['\n  border-radius: 50%;\n  height: ', ';\n  width: ', ';\n  object-fit: cover;\n  box-shadow: s-depth(100);\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import { isNil } from 'ramda';

var getSizeDimension = function getSizeDimension(props) {
  var hasSize = !isNil(props.size);

  if (hasSize) {
    return props.theme.avatar.sizes[props.size];
  }

  return '40px';
};

var StyledAvatar = styled.div(_templateObject);
var StyledImg = styled.img(_templateObject2, function (props) {
  return getSizeDimension(props);
}, function (props) {
  return getSizeDimension(props);
});

var Avatar = function (_React$Component) {
  _inherits(Avatar, _React$Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Avatar.prototype.render = function render() {
    return React.createElement(StyledAvatar, null, React.createElement(StyledImg, _extends({}, this.props, {
      alt: 'Avatar Image'
    })));
  };

  return Avatar;
}(React.Component);

export { Avatar as default };